// extracted by mini-css-extract-plugin
module.exports = {"searchBoxRainbow":"rainbowStyle_searchBoxRainbow__zBMcS","borderAnimation":"rainbowStyle_borderAnimation__AxROu","inputWrapperRainbow":"rainbowStyle_inputWrapperRainbow__YD_C8"};